import { render, staticRenderFns } from "./ParentSelectorsV2.vue?vue&type=template&id=59ce1eee&scoped=true&"
import script from "./ParentSelectorsV2.vue?vue&type=script&lang=ts&"
export * from "./ParentSelectorsV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ce1eee",
  null
  
)

export default component.exports